import type {
  PromotionAnalyticsSummary,
  PromotionEventType,
  TranslationKey,
} from '@dukanti/shared';
import { useTranslation } from '@dukanti/shared';

const LABELS: Record<PromotionEventType, TranslationKey> = {
  link_visit: 'admin.promotionKit.analytics.linkVisits',
  product_detail_view: 'admin.promotionKit.analytics.productViews',
  contact_click: 'admin.promotionKit.analytics.contactClicks',
  add_to_cart_click: 'admin.promotionKit.analytics.addToCartClicks',
  order_start_click: 'admin.promotionKit.analytics.orderStartClicks',
};

export function PromotionAnalyticsSummaryCard(props: {
  readonly analytics: PromotionAnalyticsSummary | null;
}): React.JSX.Element {
  const { t } = useTranslation();
  const totals = props.analytics?.totals ?? [];
  return (
    <section className="border-border bg-card shadow-admin-card rounded-lg border p-4">
      <h2 className="font-display text-foreground text-xl">
        {t('admin.promotionKit.analytics.title' as TranslationKey)}
      </h2>
      <div className="mt-4 grid gap-3 sm:grid-cols-2">
        {totals.map((item) => (
          <div key={item.eventType} className="bg-admin-surface-muted rounded-lg p-3">
            <p className="text-muted-foreground text-xs">{t(LABELS[item.eventType])}</p>
            <p className="text-foreground mt-1 text-2xl font-semibold">{item.count}</p>
            {item.countOverflowed ? (
              <p className="text-destructive mt-1 text-xs">
                {t('admin.promotionKit.analytics.countOverflowed' as TranslationKey)}
              </p>
            ) : null}
          </div>
        ))}
      </div>
    </section>
  );
}
